import type { ReactNode } from 'react';
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const UserLoginType = {
  LOGIN: 'login',
  SIGNUP: 'signup',
} as const;

export const UserLoginSource = {
  GOOGLE: 'google',
  EMAIL: 'email',
  FACEBOOK: 'meta',
} as const;

export const UserLoginOrigin = {
  PROMPT: 'payerprompt',
  TRACKING: 'tracking',
  MENU: 'menu',
} as const;

type UserLoginType = (typeof UserLoginType)[keyof typeof UserLoginType];

export interface LoginContextInterface {
  loginOrigin: string;
  setLoginOrigin: React.Dispatch<React.SetStateAction<string>>;
}

const LoginContext = createContext<LoginContextInterface>({
  loginOrigin: UserLoginOrigin.MENU,
  setLoginOrigin: () => {},
});

function LoginContextProvider({
  children,
  loginOrigin: initialOrigin,
}: {
  children: ReactNode;
  loginOrigin: string;
}) {
  const location = useLocation();
  const [loginOrigin, setLoginOrigin] = useState<string>(initialOrigin);

  const value: LoginContextInterface = {
    loginOrigin,
    setLoginOrigin,
  };

  useEffect(() => {
    if (!loginOrigin) {
      const pathLocation = location.pathname;
      const origin = pathLocation.includes('/tracking')
        ? UserLoginOrigin.TRACKING
        : UserLoginOrigin.MENU;
      setLoginOrigin(origin);
    }
  }, [location.pathname, loginOrigin]);

  return (
    <LoginContext.Provider value={value}>{children}</LoginContext.Provider>
  );
}

export { LoginContext, LoginContextProvider };
